import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Button } from '../../core/styles/styledComponents';
import styled from 'styled-components';
import { theme } from '../../core/styles/theme';

const Logo = styled.img`
  height: 50px;
  margin: ${theme.spacing.lg} 0;
`;

const CheckEmailContainer = styled(Container)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.background.default};
`;

const CheckEmailCard = styled(Card)`
  width: 100%;
  max-width: 400px;
  margin-top: ${theme.spacing.lg};
  text-align: center;
`;

const CheckEmailPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <CheckEmailContainer>
            <Logo src="/EureekaBi.png" alt="EureekaBI Logo" />
            <CheckEmailCard>
                <h2 style={{ marginBottom: theme.spacing.lg }}>Check Your Email</h2>
                <p style={{ marginBottom: theme.spacing.lg, textAlign: 'center' }}>
                    If an account exists for this email, you will receive a password reset link.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.sm }}>
                    <Button
                        type="button"
                        variant="primary"
                        onClick={() => navigate('/forgot-password')}
                    >
                        Try Different Email
                    </Button>
                    <Button
                        type="button"
                        variant="minimal"
                        onClick={() => navigate('/login')}
                    >
                        Back to Login
                    </Button>
                </div>
            </CheckEmailCard>
        </CheckEmailContainer>
    );
};

export default CheckEmailPage; 